import FindYourSchool from "./FindYourSchool";
import PrivacyStatement from "./PrivacyStatement";

/**
 * Campaign copy between the hero banner and the interactive map.
 *
 * Built from NSW Design System primitives: a section (`nsw-section` with an
 * `nsw-container`), plain h2 and p for body copy — the design system styles
 * those elements directly rather than through component classes — the
 * details-based accordion grouping the "can't find your school" note and
 * the privacy statement, and an info in-page alert for the closing date,
 * since that is a notice readers must not miss rather than ordinary body
 * copy.
 *
 * The design system zeroes heading margins and 3.26.3 ships no rich-text
 * wrapper, so vertical rhythm between the two groups comes from its spacing
 * utilities (`nsw-m-top-xl`: 2rem, rising to 4rem from 62rem wide).
 */
/** The campaign's own page on nsw.gov.au. */
const WORLD_TEACHERS_DAY_URL =
  "https://www.nsw.gov.au/education-and-training/nesa/awards-and-events/world-teachers-day";

const IntroContent = () => (
  <section className="nsw-section" aria-labelledby="celebrate-heading">
    <div className="nsw-container">
      <h2 id="celebrate-heading">Celebrate your teaching gems!</h2>
      <p>
        To celebrate{" "}
        <a href={WORLD_TEACHERS_DAY_URL}>World Teachers’ Day in NSW</a>{" "}
        (#WTD2026) on Friday 30 October 2026, we invite school communities to
        join our statewide treasure hunt for teaching gems.
      </p>
      <p>
        A gem is a past or present teacher who inspires, motivates and makes a
        difference to you and others.
      </p>

      <h2 className="nsw-m-top-xl">How to pin gems on the NSW Teaching Map</h2>
      <p>
        Click on the ‘Message’ button below to give a shout out to a teacher in
        your community. Add your school’s postcode to make sure your gem is
        pinned in the right spot! Type in your teacher’s initials and a short
        personal message.
      </p>
      <p>
        You will <strong>not</strong> be asked for your name, email address or
        any personal information. All submissions are anonymous.
      </p>

      <div className="nsw-accordion">
        <FindYourSchool />
        <PrivacyStatement />
      </div>

      <div className="nsw-in-page-alert nsw-in-page-alert--info">
        <span
          className="material-icons nsw-material-icons nsw-in-page-alert__icon"
          focusable="false"
          aria-hidden="true"
        >
          info
        </span>
        <div className="nsw-in-page-alert__content">
          <p>
            Please note submissions for the Teaching Gems Map are now closed.
            You can still explore the Map and the messages below.
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default IntroContent;
